module.exports = __webpack_public_path__ + "img/video-bf.9374ab46.png";